import type { SocialUserFeedQuery } from '@web/gen/feed'
import { NoPosts } from './no-posts'
import { PageClient } from '../page-client'
import * as React from 'react'
import type { Project } from '../../../masterfeed/page-client'
import { useSocialUserFeedQuery } from '@web/app/[locale]/(web)/masterfeed/_hooks/use-social-dicovery-feed'

export function CrafterFeed({
  slug,
  initialData,
}: {
  slug: string
  initialData: SocialUserFeedQuery
}) {
  const { data, hasNextPage, fetchNextPage } = useSocialUserFeedQuery({
    slug,
    initialData,
  })

  const userFeed = data?.pages.flatMap(
    page => page.socialUserFeed?.posts,
  ) as SocialUserFeedQuery['socialUserFeed']['posts']

  if (userFeed?.length === 0) {
    return <NoPosts slug={slug} />
  }

  return (
    <PageClient
      userFeed={userFeed as Project[]}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      slug={slug}
    />
  )
}
